import Layout from '@/layout'

/**
 * 扶摇外部系统路由
 *
 */

const externalSysRouters = [
  {
		path: '/external',
		component: Layout,
		children: [
			{
				path: '/external/index',
        name: 'ExternalSystemLayout',
				component: () => import('@/views/external/index'),
				hidden: true,
			},
		]
	}
]
export {
  externalSysRouters
}
